export default __webpack_public_path__ + "static/media/table.5e45f06d.svg";